import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const nameMessages = defineMessages({
  required: {
    id: 'lines.new.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'lines.new.form.name.max',
    defaultMessage: 'The name can be up to 255 characters'
  }
})

const logoMessages = defineMessages({
  required: {
    id: 'lines.new.form.logo.required',
    defaultMessage: 'The logo is required'
  }
})

const classMessages = defineMessages({
  required: {
    id: 'lines.new.form.class.required',
    defaultMessage: 'The class is required'
  }
})

const refundRulesMessages = defineMessages({
  required: {
    id: 'lines.new.form.refundRules.required',
    defaultMessage: 'The refunding rules is required'
  },
  max: {
    id: 'lines.new.form.refundRules.max',
    defaultMessage: 'The refunding rules can be up to 255 characters'
  }
})

export const newLineSchema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(255, intl.formatMessage(nameMessages.max)),
    logo: yup.string().required(intl.formatMessage(logoMessages.required)),
    class: yup.string().required(intl.formatMessage(classMessages.required)),
    refundRules: yup
      .string()
      .required(intl.formatMessage(refundRulesMessages.required))
      .max(255, intl.formatMessage(refundRulesMessages.max))
  })
}
